let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hTb1M"), load("02UZz"), load("aZwOd"), load("k9ktU")]).then(() => parcelRequire('iFaMg'));